export default {
  scroll: { page: 'Seitenposition', panel: 'Position in der Liste' },
  pagerAria: 'Seiten der Liste',
  time: {
    today: 'Heute', yesterday: 'Gestern', tomorrow: 'Morgen', now: 'gerade eben',
    todayAt: 'heute {{time}}', yesterdayAt: 'gestern {{time}}', tomorrowAt: 'morgen {{time}}',
    inH: 'in {{h}} Std.', inM: 'in {{m}} Min.', inHM: 'in {{h}} Std. {{m}} Min.',
    msk: 'MSK', hours: '{{count}} Std.', hoursShort: 'Std.', minShort: 'Min.', every: 'alle {{h}} Std.', everyShort: 'alle {{h}}',
    onceADay: 'einmal täglich', daily: 'täglich', hourly: 'stündlich', zone: 'Zeit: {{zone}}',
  },
  date: { since: 'seit {{date}}', sinceApprox: 'etwa seit {{month}}', periodApprox: '{{month}}, ungefähr', noDate: 'kein Datum' },
  unit: {
    coin_one: '{{count}} Coin', coin_other: '{{count}} Coins',
    material_one: '{{count}} Meldung', material_other: '{{count}} Meldungen',
    source_one: '{{count}} Quelle', source_other: '{{count}} Quellen',
    event_one: '{{count}} Termin', event_other: '{{count}} Termine',
    transfer_one: '{{count}} Transfer', transfer_other: '{{count}} Transfers',
    alert_one: '{{count}} Alert', alert_other: '{{count}} Alerts',
    day_one: '{{count}} Tag', day_other: '{{count}} Tage',
    purchase_one: '{{count}} Kauf', purchase_other: '{{count}} Käufe',
    question_one: '{{count}} Frage', question_other: '{{count}} Fragen',
    asset_one: '{{count}} Asset', asset_other: '{{count}} Assets',
    network_one: '{{count}} Netzwerk', network_other: '{{count}} Netzwerke',
    post_one: '{{count}} Post', post_other: '{{count}} Posts',
    signal_one: '{{count}} Signal', signal_other: '{{count}} Signale',
    piece: '{{qty}}',
  },
  action: {
    close: 'Schließen', cancel: 'Abbrechen', save: 'Speichern', retry: 'Erneut versuchen', open: 'Öffnen', show: 'Anzeigen', later: 'Später', done: 'Fertig',
    back: 'Zurück', more: 'Mehr', change: 'Ändern', delete: 'Löschen', all: 'Alle', allCoins: 'Alle Coins', copy: 'Kopieren', copied: 'Kopiert',
    understood: 'Verstanden', enable: 'Einschalten', settings: 'Einstellen', toTop: 'Nach oben', loading: 'Wird geladen…', checking: 'Wird geprüft…',
  },
  state: {
    loadFailed: '{{what}} konnte nicht geladen werden', loadFailedText: 'Der Rest der Seite funktioniert. Versuch es noch einmal — meist hilft das.',
    sheetFailed: 'Daten konnten nicht geladen werden. Schließe das Panel und versuch es erneut.',
    on: 'an', off: 'aus', yes: 'ja', no: 'nein',
  },
  plan: { free: 'Free', plus: 'Plus', premium: 'Premium' },
  footer: { slogan: 'Weniger Rauschen. Mehr Klarheit.' },
  a11y: { close: 'Schließen', menu: 'Alle Bereiche', closeMenu: 'Menü schließen', theme: 'Design', toDark: 'Dunkles Design', toLight: 'Helles Design', dark: 'Dunkel', light: 'Hell', importance: 'Relevanz {{n}} von 3' },
};
